"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3.09 4.44c-.39.39-.39 1.02 0 1.41l2.03 2.03-.12.13V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.17 1.17c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L4.5 4.44a.996.996 0 0 0-1.41 0M19 16.11V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06z"
}), 'NoSimRounded');